module.exports = __webpack_public_path__ + "media/wheel.fe6deef3.mp3";